export default "__VITE_ASSET__Bc6OjF_p__"